import React from 'react';
import { useNavigate } from 'react-router';

import EmptyableCard from '../../../../components/Card/EmptyableCard';
import ShiftCard from '../../../../components/Card/ShiftCard';
import { IActiveShifts } from '../../../../models/dashboard/jobs/getActiveShifts.model';
import { useAppSelector } from '../../../../redux/store';
import { APPLICATION, LOCUMJOBS } from '../../../../routes/routeConstants';
import styled from '@emotion/styled';

const ActiveShifts = () => {
  const navigate = useNavigate();
  const allActiveShifts = useAppSelector((state) => state.activeShifts);

  const emptyClick = () => {
    navigate(`/${LOCUMJOBS}`);
  };

  return (
    <EmptyableCard
      label="Your Active Shift"
      emptyViewNote={
        <Viewnote>
          You currently don't have any active shift,
          <span onClick={emptyClick}> click here</span> to get started
        </Viewnote>
      }
      viewAllClick={() => navigate(`/${APPLICATION}`)}
    >
      {allActiveShifts?.jobData?.map((data: IActiveShifts, index: number) => (
        <ShiftCard key={index} job={data} />
      ))}
    </EmptyableCard>
  );
};

export default ActiveShifts;

const Viewnote = styled.span`
  font-size: 18px;
  font-weight: 400;
  line-height: 26.91px;
  letter-spacing: -1px;

  & > span {
    color: ${({ theme }) => theme.palette.mainBlue};
  }
`;
